const NO_EXPIRATION = 0;
const UNIQUE_EXPIRATION_DATE = 1;
const UNIQUE_EXPIRATION_IN_X_DAYS = 2;
const MONTHLY_CYCLICAL_EXPIRATION = 3;
const ANNUAL_CYCLICAL_EXPIRATION = 4;

export default {
  NO_EXPIRATION,
  UNIQUE_EXPIRATION_DATE,
  UNIQUE_EXPIRATION_IN_X_DAYS,
  MONTHLY_CYCLICAL_EXPIRATION,
  ANNUAL_CYCLICAL_EXPIRATION
};
